<script setup>
// "Reports" button with a dropdown of printable PDFs.
defineProps({
  // [{ title, path }], or { title, options: [{ title, path }] } for a report
  // that comes in versions (e.g. one per quarter).
  reports: { type: Array, required: true },
});
const emit = defineEmits(['open']);
</script>

<template>
  <v-menu location="bottom end" offset="6">
    <template #activator="{ props: menuProps }">
      <v-btn v-bind="menuProps" variant="outlined" prepend-icon="mdi-file-download-outline">
        Reports
        <v-icon end size="16">mdi-chevron-down</v-icon>
      </v-btn>
    </template>
    <div class="reports" role="menu">
      <p class="reports__label">Download PDF</p>
      <template v-for="report in reports" :key="report.title">
        <div v-if="report.options" class="reports__group">
          <div class="reports__group-title">
            <v-icon size="16">mdi-file-pdf-box</v-icon>
            {{ report.title }}
          </div>
          <div class="reports__options">
            <button
              v-for="option in report.options"
              :key="option.path"
              type="button"
              role="menuitem"
              class="reports__option"
              @click="emit('open', option)"
            >
              {{ option.title }}
            </button>
          </div>
        </div>
        <button v-else type="button" role="menuitem" class="reports__item" @click="emit('open', report)">
          <v-icon size="16">mdi-file-pdf-box</v-icon>
          {{ report.title }}
        </button>
      </template>
    </div>
  </v-menu>
</template>

<style scoped>
.reports {
  min-width: 220px;
  padding: 4px;
  background: var(--card);
  border: 1px solid var(--border);
  border-radius: 10px;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1);
}
.reports__label {
  margin: 0;
  padding: 6px 8px;
  font-size: 12px;
  font-weight: 500;
  color: var(--muted-foreground);
}
.reports__item {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  padding: 7px 8px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: var(--foreground);
  font: inherit;
  font-size: 14px;
  text-align: left;
  cursor: pointer;
}
.reports__item:hover,
.reports__item:focus-visible {
  outline: none;
  background: var(--accent);
}
.reports__item .v-icon,
.reports__group-title .v-icon {
  color: var(--muted-foreground);
}
.reports__group {
  padding: 7px 8px;
}
.reports__group-title {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
}
.reports__options {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  margin: 6px 0 0 24px;
}
.reports__option {
  padding: 3px 8px;
  border: 1px solid var(--border);
  border-radius: 6px;
  background: transparent;
  color: var(--foreground);
  font: inherit;
  font-size: 12px;
  cursor: pointer;
}
.reports__option:hover,
.reports__option:focus-visible {
  outline: none;
  background: var(--accent);
}
</style>
